<template>
  <div>
    <div class="question__item">
      <BaseContent :info="params"></BaseContent>
      <el-form class="question__form">
        <el-form-item class="question__form--item">
          <div class="group__item">
            <el-input
              @input.native="changeInput"
              v-show="form.q_property === `int` || form.q_property === ``"
              @blur="changeInput"
              placeholder=""
              v-model="form.q_answer_info"
              clearable>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item v-show="form.q_property === `date`">
          <div class="el-form-item__content">
            <el-date-picker
              v-model="form.q_answer_info"
              @change="changeInput"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item v-show="form.q_property === `time`">
          <div class="el-form-item__content">
            <el-time-picker
              v-model="form.q_answer_info_date"
              @change="changeTimeInput"
              :picker-options="{
                selectableRange: '00:00:00 - 23:59:59'
              }"
              placeholder="任意时间点">
            </el-time-picker>
          </div>
        </el-form-item>
      </el-form>
      <ErrMessage
        v-show="errShow"
        :title="errTitle"
        :visible="errShow"
      >
      </ErrMessage>
    </div>
    <check-item
      :check="params.check"
      :form="form"
      v-on="$listeners"
      v-bind="$attrs"
      @upCheck="upCheck"></check-item>
  </div>
</template>
<script>
import ErrMessage from '../../components/errorMessage'
import BaseContent from './baseContent'
import { BASE_TYPE_CHECK_DATA_FUN } from '../constant/index'
import * as CHECK_DATA_FUN from '../constant/method'
import { mixin } from '../constant/mixin'
import CheckItem from './checkItem'
export default {
  name: 'typeText',
  props: {
    params: {
      type: Object,
      default () {
        return {
        }
      }
    }
  },
  mixins: [mixin],
  data () {
    return {
      form: {
        q_category: '',
        question_id: '',
        q_answer_info: '',
        q_answer_info_date: '',
        q_remark: '',
        q_option_id: '',
        q_is_required: 0,
        o_is_required: 0,
        o_has_input: 0,
        o_is_conflict: 0,
        data_datetime: '',
        is_kaocha: '',
        remark: '',
        q_group_id: '',
        q_number: '',
        q_property: 'int', // 填空题新增三种属性
        max: '',
        min: '',
        relation: '',
        equal: '',
        neq: ''
      },
      info: {},
      errShow: false,
      errTitle: '请输入内容'
    }
  },
  computed: {
    checkFun () {
      return CHECK_DATA_FUN[BASE_TYPE_CHECK_DATA_FUN[this.form.q_category]]
    }
  },
  methods: {
    checkData (isSubmit) {
      let checkResult = this.checkFun(this.form, this.params)
      if (checkResult.noData) {
        this.errShow = true
        this.errTitle = checkResult.errTitle
      } else {
        this.errShow = false
        !isSubmit && this.logicalHandler()
      }
    },
    changeInput () {
      this.checkData()
    },
    changeTimeInput (val) {
      this.q_answer_info = val && String(val).split('2019')[1].split('GMT+0800 (中国标准时间)')[0].trim()
      // console.log(this.q_answer_info)
      this.checkData()
    },
    upCheck (val) {
      this.form = Object.assign(this.form, val)
    }
  },
  watch: {
    form: {
      handler (val) {
        console.log()
        this.$emit('pick', val)
      },
      deep: true
    }
  },
  components: {
    ErrMessage,
    BaseContent,
    CheckItem
  },
  mounted () {
    this.info = { ...this.info, ...this.params }
    Object.keys(this.form).forEach(item => {
      this.form[item] = this.params[item] || ''
      if (this.form['q_property'] === 'time') {
        let date_arr = this.form.q_answer_info && this.form.q_answer_info.split(':')
        this.form.q_answer_info_date = new Date(2019, 9, 18, date_arr[0], date_arr[1], date_arr[2])
      }
      if (item === 'data_datetime') {
        this.form[item] = this.params.check[0] && this.params.check[0].data_datetime
      }
      if (item === 'remark') {
        this.form[item] = this.params.check[0] && this.params.check[0].remark
      }
    })
  }
}
</script>
